import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  uiSettingsUrl = `${environment.NEW_BACKEND_URL}api/uiSettings`;
  posSettingsUrl = `${environment.NEW_BACKEND_URL}api/posSettings`;

  constructor(private http: HttpClient) {}

  getSettingByStore(storeId: number) {
    return this.http.get(`${this.uiSettingsUrl}/getById?storeId=${storeId}`);
  }

  ///
  getPosSettings(storeId: number, businessId: number) {
    return this.http.get(
      `${this.posSettingsUrl}/getPosSettings?storeId=${storeId}&businessId=${businessId}`
    );
  }
  //   getPosSettingsForStore

  getPosSettingsForStore(storeId: number) {
    return this.http.get(
      `${this.posSettingsUrl}/getPosSettingsForStore?storeId=${storeId}`
    );
  }
}
